import { render, staticRenderFns } from "./RolesMain.vue?vue&type=template&id=0239f859&scoped=true&"
import script from "./RolesMain.vue?vue&type=script&lang=js&"
export * from "./RolesMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0239f859",
  null
  
)

export default component.exports